import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Filters as LoadingOrdersFilter } from 'hooks/store/loading-orders';

export type Filters = LoadingOrdersFilter;

type State = {
  filters: Filters;
  reportColumns: string[];
};

type Actions = {
  updateFilters: (filters: Filters) => void;
  updateReportColumns: (reportColumns: string[]) => void;
  updateStatuses: (statuses: string[]) => void;
  clearState: () => void;
};

const getInitialState = () => ({
  filters: {},
  reportColumns: [],
});

export const useUnloadingOrdersSearchParams = create(
  persist<State & Actions>(
    (set, get) => ({
      ...getInitialState(),
      updateFilters: (filters) => set({ filters }),
      updateReportColumns: (reportColumns) => set({ reportColumns }),
      updateStatuses: (statuses) => set({ filters: { ...get().filters, statuses } }),
      clearState: () => set(getInitialState()),
    }),
    {
      name: 'unloading-orders-search-params-v1',
      // @ts-ignore
      partialize: (state) => ({
        reportColumns: state.reportColumns,
      }),
    }
  )
);